<template>
  <vs-row v-if="completed_experiences.length > 0">
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" class="w-full xl:w-9/12">
      <vx-card :class="cardClass">
        <div>
          <Heading :size="$route.params.id ? 'h2' : 'h1'" styleSize="h4" class="mb-2">
            Reflection</Heading
          >
          <p class="my-5">
            This is where you get to think about your Work Experience - what you learned and whether
            you could see yourself going into this job in the future. You must complete the
            information below before you request your certificate.
          </p>
          <form id="form" @submit.prevent="preventSubmit(false)">
            <div
              class="vx-row mb-6"
              v-show="completed_experiences.length > 1 && canChooseReflection"
            >
              <div class="vx-col sm:w-2/3 w-full">
                <label>
                  Select Work Experience
                  <select
                    v-model="vje_id"
                    class="defaultselect mt-0"
                    style="width: 100%"
                    @change="changedVje"
                  >
                    <option value="0">
                      Please select the job experience you want to add this Reflection to
                    </option>
                    <option
                      v-for="vje in completed_experiences"
                      :key="vje.student_vje_id"
                      :value="vje.student_vje_id"
                    >
                      {{ vje.vje }} (Completed: {{ vje.date }})
                    </option>
                  </select>
                </label>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-2/3 w-full">
                <label>
                  Name of Job/Career experienced:
                  <vs-input class="w-full" v-model="data.job_name" @change="handleChange" />
                </label>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>What enterprise skills do you feel you developed?</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="vx-row mb-6">
                  <li
                    class="vx-col sm:w-1/2 lg:w-1/3 w-full my-1 focusable-parent"
                    v-for="skill in skills"
                    :key="skill"
                  >
                    <label class="focus-visible-style">
                      <vs-checkbox
                        role="checkbox"
                        v-model="data.skills"
                        :vs-value="skill"
                        @change="submitForm(false)"
                        >{{ skill }}
                      </vs-checkbox>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>What are 3 things you learned about this job?</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vx-input-group class="mb-base">
                  <template slot="prepend">
                    <div class="prepend-text bg-primary">
                      <span>1</span>
                    </div>
                  </template>
                  <vs-input
                    aria-label="3 things you learned about this job #1"
                    v-model="data.learned1"
                    @change="handleChange"
                  />
                </vx-input-group>
                <vx-input-group class="mb-base">
                  <template slot="prepend">
                    <div class="prepend-text bg-primary">
                      <span>2</span>
                    </div>
                  </template>
                  <vs-input
                    aria-label="3 things you learned about this job #2"
                    v-model="data.learned2"
                    @change="handleChange"
                  />
                </vx-input-group>
                <vx-input-group class="mb-base">
                  <template slot="prepend">
                    <div class="prepend-text bg-primary">
                      <span>3</span>
                    </div>
                  </template>
                  <vs-input
                    aria-label="3 things you learned about this job #3"
                    v-model="data.learned3"
                    @change="handleChange"
                  />
                </vx-input-group>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Can you see yourself doing this job in the future?</span>
              </div>
              <div class="vx-col vx-row mb-5">
                <div class="vx-col w-full focusable-parent">
                  <vs-radio
                    v-model="data.do_job_in_future"
                    class="checkbox_answer multiline focus-visible-style"
                    :vs-value="1"
                    vs-name="do_job_in_future"
                    @change="submitForm(false)"
                    >Yes
                  </vs-radio>
                </div>
                <div class="vx-col w-full focusable-parent">
                  <vs-radio
                    v-model="data.do_job_in_future"
                    class="checkbox_answer multiline focus-visible-style"
                    :vs-value="0"
                    vs-name="do_job_in_future"
                    @change="submitForm(false)"
                    >No
                  </vs-radio>
                </div>
                <div class="vx-col w-full focusable-parent">
                  <vs-radio
                    v-model="data.do_job_in_future"
                    class="checkbox_answer multiline focus-visible-style"
                    :vs-value="2"
                    vs-name="do_job_in_future"
                    @change="submitForm(false)"
                    >I'm Unsure
                  </vs-radio>
                </div>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Additional thoughts/reflections (optional):</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full focusable-parent">
                <vs-textarea
                  class="focus-visible-style"
                  aria-label="Additional thoughts/reflections"
                  v-model="data.reflections"
                  height="200px"
                  @change="submitForm(false)"
                />
              </div>
            </div>

            <button
              class="btn btn-primary btn-size-medium mr-3"
              @click="submitForm(true)"
              :disabled="vje_id == 0"
            >
              Save
            </button>
            <button
              id="view-reflection-btn"
              class="btn btn-secondary btn-size-medium"
              @click="downloadReflection"
              v-if="canDownload"
            >
              View Reflection
            </button>
            <vs-progress indeterminate color="primary" v-if="downloadingReflection"></vs-progress>
          </form>

          <vs-alert
            class="mt-5"
            :color="alertStatus"
            :title="alertTitle"
            active="true"
            v-if="showAlert"
          >
            {{ alertMessage }}
          </vs-alert>
        </div>
      </vx-card>
    </vs-col>
    <vs-col
      vs-type="flex"
      vs-justify="center"
      class="w-full xl:w-3/12 pt-10 xl:pl-10 xl:pt-0"
      v-if="showTips"
    >
      <vx-card>
        <h4 class="mb-5">Tips & Tricks</h4>
        <p class="mb-5">"The only place where success comes before work is in the dictionary.”</p>
        <p>(Vince Lombardi)</p>
      </vx-card>
    </vs-col>
  </vs-row>

  <no-completed-vje v-else>
    <p class="mb-5">You need to complete a Job Experience to reflect upon.</p>
  </no-completed-vje>
</template>

<script>
import { successToast, errorToast } from '@/utils/toast';
import themeConfig from '@/../themeConfig';
import NoCompletedVje from '@/components/UI/students/NoCompletedVje';
import theApi from '@/mixins/theApi';
import store from '@/store/store';
import router from '@/router/router';

export default {
  components: { NoCompletedVje },
  data() {
    return {
      //completed_vje: [],
      vje_id: 0,
      skills: [
        'Communication',
        'Teamwork',
        'Problem Solving',
        'Collaboration',
        'Flexibility',
        'Digital Literacy',
        'Presentation Skills',
        'Critical Thinking',
        'Creativity',
        'Financial Literacy',
        'Initiative and Enterprise',
        'Planning and Organising',
        'Self Management',
        'Learning and Technology',
      ],
      data: {
        job_name: '',
        skills: [],
        learned1: '',
        learned2: '',
        learned3: '',
        do_job_in_future: 0,
        reflections: '',
      },
      sidebarWidth: themeConfig.sidebarWidth,
      showAlert: false,
      alertStatus: 'success',
      alertMessage: '',
      alertTitle: 'Success',
      canDownload: false,
      downloadingReflection: false,
    };
  },
  methods: {
    preventSubmit() {
      return false;
    },
    async submitForm(formSubmitted = false) {
      if (parseInt(this.vje_id) === 0) {
        return;
      }

      if (formSubmitted) {
        if (this.data.job_name === '' || this.data.skills.length === 0) {
          this.$toast.error(
            'You must complete all of these information before you request your certificate',
            errorToast(),
          );
          return;
        }
      }
      this.showAlert = false;
      const form = document.getElementById('form');
      const formData = new FormData(form);
      for (const [key, value] of Object.entries(this.data)) {
        formData.append(key, JSON.stringify(value));
      }
      formData.append('vje_id', this.vje_id);

      theApi.methods
        .makeCall(
          false,
          'reflection/save',
          'post',
          formData,
          formSubmitted ? 'Reflection saved successfully!' : null,
          true,
        )
        .then(
          (data) => {
            const postwork_data = {
              student_vje_id: this.vje_id,
              data: data.postwork,
            };

            store.commit('authStudent/updateExperiencePostwork', postwork_data);
            this.canDownload = true;
          },
          () => {},
        );
    },
    getReflection(vje_id) {
      const item = this.completed_experiences.find((i) => i.school_student_vje_id == vje_id);
      if (item && item.reflection) {
        this.data = Object.assign({}, item.reflection);

        if (this.data.do_job_in_future === false) {
          this.data.do_job_in_future = 0;
        } else if (this.data.do_job_in_future === true) {
          this.data.do_job_in_future = 1;
        }
        this.canDownload = true;
      } else {
        this.data = {
          job_name: '',
          skills: [],
          learned1: '',
          learned2: '',
          learned3: '',
          do_job_in_future: 0,
          reflections: '',
        };
        this.canDownload = false;
      }
    },
    changedVje() {
      this.getReflection(this.vje_id);
    },
    downloadReflection() {
      const form = document.getElementById('form');
      const formData = new FormData(form);
      for (const [key, value] of Object.entries(this.data)) {
        formData.append(key, JSON.stringify(value));
      }
      formData.append('vje_id', this.vje_id);

      this.downloadingReflection = true;
      theApi.methods.makeCall(false, 'reflection/save', 'post', formData, null, true).then(
        (data) => {
          const postwork_data = {
            student_vje_id: this.vje_id,
            data: data.postwork,
          };
          store.commit('authStudent/updateExperiencePostwork', postwork_data);

          const formDataTL = new FormData();
          formDataTL.append('student_vje_id', this.vje_id);
          theApi.methods.makeCall(false, 'reflection/download', 'post', formDataTL).then(
            (data) => {
              if (data.status == 'OK') {
                store.dispatch('popup/showIframePopup', data.url);
                store.commit('popup/setFocusElemOnPopupClose', 'view-reflection-btn');
                this.downloadingReflection = false;
              }
            },
            () => {
              this.downloadingReflection = false;
            },
          );
        },
        () => {},
      );
    },
    handleChange(e) {
      if (e.target.value) {
        this.submitForm();
      }
    },
  },
  computed: {
    settings() {
      return store.getters['authStudent/settings'];
    },
    experiences() {
      return store.getters['authStudent/experiences'];
    },
    completed_experiences() {
      let completed_experiences = [];
      for (let i = 0; i < this.experiences.length; i++) {
        if (this.experiences[i].completed_for_postwork) {
          const item = Object.assign({}, this.experiences[i].postwork);
          item.vje = this.experiences[i].vje.name;
          item.date = this.experiences[i].date_completed_formatted;
          item.student_vje_id = this.experiences[i].id;
          completed_experiences.push(item);
        }
      }

      return completed_experiences;
    },
    cardClass() {
      if (typeof this.$route.meta.showTips !== 'undefined' && !this.$route.meta.showTips) {
        return 'mt-base';
      }
      return '';
    },
    showTips() {
      if (typeof this.$route.meta.showTips !== 'undefined' && !this.$route.meta.showTips)
        return false;
      return true;
    },
    canChooseReflection() {
      if (
        typeof this.$route.meta.canChooseReflection !== 'undefined' &&
        !this.$route.meta.canChooseReflection
      )
        return false;
      return true;
    },
    contentWidth() {
      if (this.showTips) return themeConfig.contentWidth;
      return 12;
    },
  },
  mounted() {
    if (
      typeof this.settings['reflection'] !== 'undefined' &&
      this.settings['reflection'] == false
    ) {
      router.push('/student/dashboard');
    } else {
      if (this.completed_experiences.length > 0) {
        if (
          typeof this.$route.meta.autoSelectReflection !== 'undefined' &&
          typeof this.$route.meta.autoSelectReflection
        ) {
          this.vje_id = this.$route.params.id;
          this.getReflection(this.vje_id);
        } else {
          if (this.completed_experiences.length == 1) {
            this.vje_id = this.completed_experiences[0].student_vje_id;
            this.getReflection(this.vje_id);
          }
        }
      }
    }
  },
  watch: {
    completed_experiences() {
      if (this.completed_experiences.length > 0) {
        this.vje_id = this.vje_id || this.completed_experiences[0].student_vje_id;
        this.getReflection(this.vje_id);
      }
    },
  },
};
</script>
